import { CandidateType } from './Candidates/Candidates';

export const getChariotConnectId = (candidates: CandidateType[]) =>
  candidates?.length === 1 && candidates[0].misc_ids?.chariot_connect_id;
